import React from 'react'
import PropTypes from 'prop-types'
import CheckIcon from './icons/CheckIcon'

const LABEL_CLASS = 'tw:mb-0! tw:text-sm tw:leading-3.5 tw:text-gray-700 tw:cursor-pointer'
const INPUT_CLASS = 'tw:peer tw:absolute tw:inset-0 tw:m-0! tw:size-full tw:cursor-pointer tw:opacity-0'
const TRACK_CLASS = 'tw:pointer-events-none tw:size-full tw:rounded-full tw:bg-gray-200 tw:transition-colors '
  + 'tw:peer-checked:bg-gray-700 tw:peer-focus-visible:ring-2 tw:peer-focus-visible:ring-gray-500 '
  + 'tw:peer-focus-visible:ring-offset-2'
const CHECK_CLASS = 'tw:pointer-events-none tw:absolute tw:left-1.5 tw:top-1 tw:size-3 tw:text-white '
  + 'tw:opacity-0 tw:peer-checked:opacity-100'
const DOT_CLASS = 'tw:pointer-events-none tw:absolute tw:left-0.5 tw:top-0.5 tw:size-4 tw:rounded-full '
  + 'tw:bg-white tw:transition-transform tw:peer-checked:translate-x-5'

const Switch = ({
  id,
  checked,
  onChange,
  label,
  className = ''
}) => (
  <div className={`tw:flex tw:items-center tw:gap-2 ${className}`.trim()}>
    <label className={LABEL_CLASS} htmlFor={id}>
      {label}
    </label>
    <span className="tw:relative tw:inline-flex tw:h-5 tw:w-10 tw:shrink-0">
      <input
        checked={checked}
        className={INPUT_CLASS}
        id={id}
        role="switch"
        type="checkbox"
        onChange={onChange}
      />
      <span className={TRACK_CLASS} aria-hidden />
      <CheckIcon className={CHECK_CLASS} variant="thin" />
      <span className={DOT_CLASS} aria-hidden />
    </span>
  </div>
)

Switch.propTypes = {
  checked: PropTypes.bool.isRequired,
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

Switch.defaultProps = {
  className: ''
}

export default Switch
